import React from 'react';

import './LocationLinksEmptyPlaceholder.css';

const LocationLinksEmptyPlaceholder = () => (
  <div className="location-links-empty-placeholder">
    <div className="image-wrapper" />
  </div>
);

export default LocationLinksEmptyPlaceholder;
